import React, { useCallback, useEffect, useState } from "react";
import { FileText, ChevronDown, Send, AlertTriangle, History, FileStack, MessageSquarePlus } from "lucide-react";
import MessageModal from "./MessageModal";
import { api } from "../lib/api";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger,
} from "./ui/dropdown-menu";
import SendDocModal from "./SendDocModal";
import EnvoiPoseFlowModal from "./EnvoiPoseFlowModal";
import EnvoiPoseModal from "./EnvoiPoseModal";
import DossierPoseModal from "./DossierPoseModal";

export default function DocumentsMenu({ dossier, filter, label = "Documents", testid = "documents-menu", onSent, showPose = true }) {
  const [cat, setCat] = useState(null);
  const [send, setSend] = useState(null);
  const [modal, setModal] = useState(null);
  const load = useCallback(() => api.get(`/dossiers/${dossier.id}/send-catalog`).then((r) => setCat(r.data)).catch(() => setCat({ groups: [] })), [dossier.id]);
  useEffect(() => { load(); }, [load, dossier.updated_at]);
  const groups = (cat?.groups || []).map((g) => ({ ...g, items: g.items.filter((i) => i.applicable && (!filter || filter(i))) })).filter((g) => g.items.length);
  const done = () => { load(); onSent?.(); };
  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button className="btn-secondary text-xs" data-testid={testid}><FileText className="w-3.5 h-3.5" /> {label} <ChevronDown className="w-3 h-3" /></button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-80 max-h-[min(70vh,var(--radix-dropdown-menu-content-available-height))] overflow-y-auto">
          <DropdownMenuItem onSelect={() => setModal("message")} data-testid={`${testid}-message`} className="font-medium"><MessageSquarePlus className="w-3.5 h-3.5 mr-2" /> Écrire un message (modèle)</DropdownMenuItem>
          <DropdownMenuSeparator />
          {showPose && <>
            <DropdownMenuItem onSelect={() => setModal("flow")} data-testid={`${testid}-envoi-pose`} className="font-medium"><Send className="w-3.5 h-3.5 mr-2" /> Envoi en pose (OM + dossier de pose)</DropdownMenuItem>
            <DropdownMenuItem onSelect={() => setModal("assemble")} data-testid={`${testid}-assemble`}><FileStack className="w-3.5 h-3.5 mr-2" /> Préparer le dossier de pose</DropdownMenuItem>
            <DropdownMenuSeparator />
          </>}
          {groups.map((g) => (
            <React.Fragment key={g.name}>
              <DropdownMenuLabel className="text-[11px] uppercase tracking-wider text-norea-textMuted">{g.name}</DropdownMenuLabel>
              {g.items.map((i) => (
                <DropdownMenuItem key={i.id} onSelect={() => setSend(i)} data-testid={`${testid}-item-${i.id}`}>
                  <span className="flex-1 truncate">{i.name}</span>
                  {i.missing > 0 && <AlertTriangle className="w-3 h-3 text-amber-600 ml-2" title={`${i.missing} champ(s) vide(s)`} />}
                </DropdownMenuItem>
              ))}
            </React.Fragment>
          ))}
          {showPose && <>
            <DropdownMenuSeparator />
            <DropdownMenuItem onSelect={() => setModal("legacy")} className="text-xs text-norea-textMuted" data-testid={`${testid}-legacy`}><History className="w-3.5 h-3.5 mr-2" /> Ancien envoi en pose (secours)</DropdownMenuItem>
          </>}
        </DropdownMenuContent>
      </DropdownMenu>
      {send && <SendDocModal dossierId={dossier.id} docIds={[send.id]} title={`Envoyer — ${send.name}`} onClose={() => setSend(null)} onSent={done} />}
      {modal === "message" && <MessageModal dossierId={dossier.id} onClose={() => setModal(null)} onSent={done} />}
      {modal === "flow" && <EnvoiPoseFlowModal dossier={dossier} onClose={() => setModal(null)} onSent={done} />}
      {modal === "assemble" && <DossierPoseModal dossierId={dossier.id} onClose={() => setModal(null)} />}
      {modal === "legacy" && <EnvoiPoseModal dossierId={dossier.id} onClose={() => setModal(null)} onSent={done} />}
    </>
  );
}
